<mat-form-field appearance="outline" style="height: 75px;">
    <mat-label>Søg</mat-label>
    <input matInput type="text" [formControl]="textControl">
</mat-form-field>

<mat-form-field style="width: fit-content;" appearance="outline">
    <mat-label>År</mat-label>
    <input matInput [matDatepicker]="dp" [formControl]="date" (blur)="setYear($event.srcElement, null)"
    enterNavigation>
    <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp startView="multi-year" (yearSelected)="setYear($event, dp)">
    </mat-datepicker>
</mat-form-field>

<mat-select-autocomplete [options]="projectTypesDropdown" [formControl]="projectTypesControl" [multiple]="false" [searchbar]="false"
    label="Projekttype">
</mat-select-autocomplete>

<app-autocomplete-chips [formControl]="projectOwnerControl" label="Projektejer" [displayFn]="consultantsService.displayFn"
[valueFn]="consultantsService.valueFn" [options]="consultants"></app-autocomplete-chips>

<app-autocomplete-chips [formControl]="departmentControl" label="Forretningsområde" [displayFn]="departmentsService.displayFn"
[valueFn]="departmentsService.valueFn" [options]="departments"></app-autocomplete-chips>

<mat-select-autocomplete [options]="finishedInvoicingDropdown" [formControl]="finishedInvoicingControl" [multiple]="false" [searchbar]="false"
    label="Færdig faktureret">
</mat-select-autocomplete>

<button mat-raised-button color="primary" (click)="reset()" style="margin-top: 10px;">Nulstil</button>